var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGraphQl = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.108 15.984H5.88m12.452 1.084-4.938 2.993m-9.13-5.483a1.64 1.64 0 1 1 0 3.281 1.64 1.64 0 0 1 0-3.28m0 0V9.42m15.47 5.16a1.64 1.64 0 1 1 0 3.28 1.64 1.64 0 0 1 0-3.28m0 0v-5.16m-8.346-4.811L5.32 14.98m7.291-10.373 6.069 10.374M10.597 3.944l-4.93 2.988m0 10.136 4.938 2.993m2.798-16.117 4.93 2.988M12 4.734a1.64 1.64 0 1 0 0-3.281 1.64 1.64 0 0 0 0 3.281M4.266 9.422a1.64 1.64 0 1 0 0-3.281 1.64 1.64 0 0 0 0 3.28m15.468 0a1.64 1.64 0 1 0 0-3.282 1.64 1.64 0 0 0 0 3.282M12 22.547a1.64 1.64 0 1 0 0-3.281 1.64 1.64 0 0 0 0 3.28"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M18.108 15.984H5.88m12.452 1.084-4.938 2.993m-9.13-5.483a1.64 1.64 0 1 1 0 3.281 1.64 1.64 0 0 1 0-3.28m0 0V9.42m15.47 5.16a1.64 1.64 0 1 1 0 3.28 1.64 1.64 0 0 1 0-3.28m0 0v-5.16m-8.346-4.811L5.32 14.98m7.291-10.373 6.069 10.374M10.597 3.944l-4.93 2.988m0 10.136 4.938 2.993m2.798-16.117 4.93 2.988M12 4.734a1.64 1.64 0 1 0 0-3.281 1.64 1.64 0 0 0 0 3.281M4.266 9.422a1.64 1.64 0 1 0 0-3.281 1.64 1.64 0 0 0 0 3.28m15.468 0a1.64 1.64 0 1 0 0-3.282 1.64 1.64 0 0 0 0 3.282M12 22.547a1.64 1.64 0 1 0 0-3.281 1.64 1.64 0 0 0 0 3.28"
  }));
});
export default SvgIconGraphQl;
export const raw = __webpack_public_path__ + "static/media/IconGraphQL.d0882f4aa4b30774efb2a6201cfc14d2.svg";